<template>
  <UApp>
    <CommonNavBar />
    <div class="page_view">
      <div class="flex flex-col justify-center items-center h-140">
        <!-- 图标 -->
        <UIcon name="line-md:close-circle-twotone" class="text-red-400 text-9xl mb-6" />
        <!-- 大标题 -->
        <h1 class="text-center lg:text-5xl text-3xl text-white font-bold lg:mb-4 mb-2">
          {{ error?.status }} {{ t(`page.error.title`) }}
        </h1>
        <!-- 正文容器 -->
        <div class="mb-4">
          <!-- 错误提示内容 -->
          <p class="mb-2 lg:text-lg text-md text-center font-semibold text-white">
            {{ errorMsg }} {{ t('page.error.subTitle') }}
          </p>
          <!-- 显示错误详情 -->
          <p v-if="isDev" class="lg:mb-6 mb-4 lg:text-md text-sm text-center text-white">
            {{ error?.statusText || error?.message }}
          </p>
        </div>
        <!-- 返回按钮 -->
        <CommonBtnPress
          :label="t(`action.goBack`)"
          :type="2"
          tralling-icon="grommet-icons:return"
          @click="useGoBack()"
        />
      </div>
    </div>
    <CommonFooter />
  </UApp>
</template>

<script lang="ts" setup>
  const { t } = useI18n()

  const error = useError()
  // 处于开发环境
  const isDev = import.meta.env.DEV

  /** 已含翻译内容的错误代码 */
  const hasI18nMsgCode = [404, 403, 500]

  /** 错误内容-正文 */
  const errorMsg = computed(() => {
    const code = error.value?.status
    return typeof code === 'number' && hasI18nMsgCode.includes(code)
      ? t(`page.error.${code}`)
      : t('page.error.unknown')
  })
</script>
